import type React from 'react';

import { AmbassadorsHeader } from '../components/AmbassadorsHeader';
import { ContractModal } from '../components/ContractModal';
import { Deliverables } from '../components/Deliverables';
import { EarningsCalculator } from '../components/EarningsCalculator';
import { FooterCta } from '../components/FooterCta';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { SideNav } from '../components/SideNav';
import { TheDeal } from '../components/TheDeal';
import { VideoWalkthrough } from '../components/VideoWalkthrough';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return (
		// Keeps the fixed SideNav rail off the text. Left only — the rail is only on the left, and
		// padding the right just narrows the content column. Targets `.container` rather than
		// padding the sections so full-bleed backgrounds stay edge-to-edge. Reverts at 1344px,
		// where the container's own centring margin reaches 64px and clears the rail unaided.
		// The revert needs `!important`: same specificity as the `lg:` rule, and their emitted
		// order isn't stable across formatter runs.
		<div className="min-[1344px]:[&_.container]:pl-0! lg:[&_.container]:pl-16">
			<AmbassadorsHeader />
			{/* The SideNav sticks within this stack, so it must wrap exactly the sections it links
			    to — FooterCta sits outside it, which is what stops the rail scrolling on over the
			    red band where its labels would be unreadable. */}
			<div className="relative">
				<SideNav />
				<Hero />
				<TheDeal />
				<VideoWalkthrough />
				<Deliverables />
				<EarningsCalculator />
				<HowItWorks />
			</div>
			<FooterCta />
			<ContractModal />
		</div>
	);
};
